module.exports = __webpack_public_path__ + "static/rf-screenshot-lists-915e7d536944ea860939513936508493.jpg";